<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-16 15:07:22
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-16 15:08:30
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'MoneyIntention',
};
</script>